/**
 * Normalise Supabase redirects that land on "/#access_token=..." to the
 * canonical "/auth/callback" route used by scout and portal.
 */
export interface LocationLike {
  pathname: string;
  search: string;
  hash: string;
}

/**
 * If the location is the root path and contains OAuth tokens in the hash,
 * returns a new path that forwards to "/auth/callback" while preserving
 * the original search+hash. Otherwise returns null.
 */
export function normalizeRootHashToCallback(loc: LocationLike): string | null {
  if (
    loc.pathname === "/" &&
    loc.hash &&
    loc.hash.includes("access_token=")
  ) {
    const search = loc.search || "";
    const hash = loc.hash || "";
    return `/auth/callback${search}${hash}`;
  }
  return null;
}



